module.exports = __webpack_public_path__ + "img/concat1.ed51a119.png";